import React, { useEffect, useRef, useState } from 'react';
import uiux3 from '../images/uiux3.jpg';
import dataS from '../images/dataS.jpg';
import uiux from '../images/uiux.jpeg';
import python from '../images/python.jpg';
import uiux2 from '../images/uiux2.jpg';

import '../Slider/slider.css';

const images = [python, uiux3, dataS, uiux2, uiux];
const delay = 2500;

function Slideshow() {
	const [index, setIndex] = useState(0);
	const timeoutRef = useRef(null);

	function resetTimeout() {
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current);
		}
	}

	useEffect(() => {
		resetTimeout();
		timeoutRef.current = setTimeout(
			() =>
				setIndex((prevIndex) =>
					prevIndex === images.length - 1 ? 0 : prevIndex + 1
				),
			delay
		);

		return () => {
			resetTimeout();
		};
	}, [index]);

	return (
		<div className="slideshow animate pop delay-4">
			<div
				className="slideshowSlider"
				style={{ transform: `translate3d(${-index * 100}%, 0, 0)` }}>
				{images.map((images, index) => (
					<img
						className={'slide'}
						key={index}
						src={images}
						alt={`Slide ${index + 1}`}
					/>
				))}
			</div>

			<div className="slideshowDots">
				{images.map((_, idx) => (
					<div
						key={idx}
						className={`slideshowDot${index === idx ? ' active' : ''}`}
						onClick={() => {
							setIndex(idx);
						}}></div>
				))}
			</div>
		</div>
	);
}
export default Slideshow;
